import React, { useState } from "react";
import "./Accordion.css";
import classNames from "classnames";
import { IconButton } from "../IconButton/IconButton";
import {
  DeleteOutlined,
  PlusSquareOutlined,
  SearchOutlined,
  MinusSquareOutlined,
} from "@ant-design/icons";

export const Accordion = ({
  icon,
  heading,
  link,
  subhead,
  onDeleteClick,
  onZoomClick,
  children,
  collapsed,
  size,
}: {
  link?:any;
  icon?: any;
  heading?: any;
  subhead?: any;
  onDeleteClick?: any;
  onZoomClick?: any;
  children?: any;
  collapsed?: boolean;
  size?: string;
}) => {
  const [collapsedState, setCollapsedState] = useState(collapsed);
  var accordionClass = classNames("accordion", {
    "accordion--condensed": size === "condensed",
  });

  return (
    <div className={accordionClass}>
      <div className="accordion__header">
        {icon && (
          <div className="accordion__header-cell accordion__header-cell--icon">
            {icon}
          </div>
        )}
        <div className="accordion__header-cell accordion__header-cell--label">
          {heading && <div className="accordion__heading">{heading} </div>}
          {subhead && <div className="accordion__subhead">{subhead}</div>}
        </div>
        {onZoomClick && (
          <div className="accordion__header-cell">
            <IconButton title="Zoom to feature" onClick={onZoomClick}>
              <SearchOutlined />
            </IconButton>
          </div>
        )}
        {onDeleteClick && (
          <div className="accordion__header-cell">
            <IconButton title="Delete item" onClick={onDeleteClick}>
              <DeleteOutlined />
            </IconButton>
          </div>
        )}
        <div className="accordion__header-cell">
          <IconButton
            title={collapsedState ? "Expand item" : "Collapse item"}
            onClick={() => setCollapsedState(!collapsedState)}
            variant={size === "condensed" ? "secondary" : "primary"}
          >
            {collapsedState ? <PlusSquareOutlined /> : <MinusSquareOutlined />}
          </IconButton>
        </div>
      </div>
      {!collapsedState && <div className="accordion__content">{children}</div>}
    </div>
  );
};
